function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import { findComponent } from "@brandwatch/axiom-utils";
import Base from "../Base/Base";
import Validate from "../Validation/Validate";
import TextInputIcon, { TextInputIconRef } from "./TextInputIcon";
import { TextInputIconWrapperRef } from "./TextInputIconWrapper";
import { TextInputButtonRef } from "./TextInputButton";
import { TextInputFeedbackRef } from "./TextInputFeedback";
import ProgressInfinite from "../Progress/ProgressInfinite";
import InputWrapper from "./InputWrapper";
import "./TextInput.css";
export default class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFocus: false
    };
  }

  handleOnBlur() {
    const {
      onBlur = () => {}
    } = this.props;
    this.setState({
      hasFocus: false
    });
    onBlur(...arguments);
  }

  handleOnFocus() {
    const {
      onFocus = () => {}
    } = this.props;
    this.setState({
      hasFocus: true
    });
    onFocus(...arguments);
  }

  render() {
    const {
      children,
      className,
      disabled,
      error,
      valid,
      inputClassName,
      invalid,
      isInProgress,
      isTarget,
      label,
      labelSpace,
      onClear,
      patterns,
      required,
      size,
      space,
      style,
      type,
      usageHint,
      usageHintPosition,
      value,
      inputRef,
      inlineLabel,
      ...rest
    } = this.props;
    const {
      hasFocus
    } = this.state;
    const icon = findComponent(children, TextInputIconRef) || findComponent(children, TextInputIconWrapperRef);
    const Button = findComponent(children, TextInputButtonRef);
    const inputFeedback = findComponent(children, TextInputFeedbackRef);
    const showOnClear = onClear && value && !isInProgress;
    const showIcon = icon && (!isInProgress || icon.props.align === "left");
    const inputContainerclasses = classnames("ax-input__container", className);
    const inputclasses = classnames("ax-input", inputClassName);
    return /*#__PURE__*/React.createElement(Validate, {
      error: error,
      patterns: patterns,
      required: required,
      value: value
    }, isValid => /*#__PURE__*/React.createElement(Base, {
      className: inputContainerclasses,
      space: space
    }, /*#__PURE__*/React.createElement(InputWrapper, {
      disabled: disabled,
      hasFocus: hasFocus,
      inlineLabel: inlineLabel,
      invalid: invalid,
      isTarget: isTarget,
      isValid: isValid,
      label: label,
      labelSpace: labelSpace,
      size: size,
      space: space,
      style: style,
      usageHint: usageHint,
      usageHintPosition: usageHintPosition,
      valid: valid,
      inputFeedback: inputFeedback
    }, showOnClear && /*#__PURE__*/React.createElement(TextInputIcon, {
      align: "right",
      name: "cross",
      onClick: onClear
    }), showIcon && icon, /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
      Component: "input",
      baseRef: inputRef,
      className: inputclasses,
      disabled: disabled,
      onBlur: this.handleOnBlur.bind(this),
      onFocus: this.handleOnFocus.bind(this),
      type: type,
      value: value
    })), isInProgress && /*#__PURE__*/React.createElement("span", {
      className: "ax-input__progress"
    }, /*#__PURE__*/React.createElement(ProgressInfinite, {
      sizeRem: "1rem"
    }))), Button ? /*#__PURE__*/React.cloneElement(Button, {
      size
    }) : null));
  }

}

_defineProperty(TextInput, "defaultProps", {
  size: "medium",
  space: "x4",
  type: "text",
  inlineLabel: false
});